import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useShallow } from "zustand/react/shallow";

import { ROUTES } from "@/constants/routes";
import {
  ONBOARDING_STATUSES,
  useAuthStore,
} from "@/features/Auth";
import { getUserConfig } from "@/features/Auth/Auth.utils";

function ProtectedRoute() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { user, accountState, passwordChange } = useAuthStore(
    useShallow(state => ({
      user: state.user,
      accountState: state.accountState,
      passwordChange: state.passwordChange,
    })),
  );

  useEffect(() => {
    if (!user || !accountState) {
      return navigate(ROUTES.LOGIN, {
        replace: true,
      });
    }

    if (
      accountState.ososOnboarding === ONBOARDING_STATUSES.INCOMPLETE
      && accountState.modules?.facilities
    ) {
      return navigate(ROUTES.OSOS_ONBOARDING, {
        replace: true,
      });
    }

    const isUserTryingToAccessOsosOnboardingPage
      = pathname === ROUTES.OSOS_ONBOARDING
      && accountState?.ososOnboarding === ONBOARDING_STATUSES.COMPLETED;

    const userConfig = getUserConfig(accountState);

    const isRestrictedUrl = userConfig.hiddenRoutes?.find(
      hiddenRoute => pathname === hiddenRoute,
    );

    if (passwordChange) {
      return navigate(ROUTES.RESET_PASSWORD, {
        replace: true,
      });
    }

    if (isUserTryingToAccessOsosOnboardingPage || isRestrictedUrl) {
      return navigate(userConfig.mainPage, {
        replace: true,
      });
    }
  }, [user,
    accountState,
    navigate,
    pathname,
    passwordChange]);

  return <Outlet />;
}

export default ProtectedRoute;
